import { useState } from 'react';
import {
  toDateTimeLocalInput,
  fromDateTimeLocalInput,
} from '../../utils/appointmentSchedule';
import { APPOINTMENT_TYPES, DEFAULT_APPOINTMENT_TYPE } from '../../utils/appointmentTypes';

const STATUSES = [
  { value: 'scheduled',   label: 'Programada'   },
  { value: 'confirmed',   label: 'Confirmada'   },
  { value: 'in-progress', label: 'En curso'     },
  { value: 'completed',   label: 'Completada'   },
  { value: 'cancelled',   label: 'Cancelada'    },
  { value: 'no-show',     label: 'No asistió'  },
];

export default function EditAppointmentModal({ appointment, onClose, onSave, onCancel }) {
  const [form, setForm] = useState({
    scheduledDate:      toDateTimeLocalInput(appointment.scheduledDate),
    duration:           appointment.duration ?? 20,
    status:             appointment.status,
    reason:             appointment.reason ?? '',
    notes:              appointment.notes  ?? '',
    type:               appointment.type   ?? DEFAULT_APPOINTMENT_TYPE,
    cancellationReason: '',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState('');

  const set = (f, v) => setForm(prev => ({ ...prev, [f]: v }));

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      await onSave({
        ...form,
        duration: Number(form.duration),
        scheduledDate: fromDateTimeLocalInput(form.scheduledDate),
      });
    } catch (err) {
      setError(err.response?.data?.message || 'Error al guardar');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-box">
        <div className="modal-header">
          <h2>Editar cita</h2>
          <button className="btn-close" onClick={onClose}>×</button>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSave} className="edit-appt-form">
          <div className="form-row">
            <label>Fecha y hora
              <input type="datetime-local" value={form.scheduledDate}
                onChange={e => set('scheduledDate', e.target.value)} />
            </label>
            <label>Duración (min)
              <input type="number" value={form.duration} min={5} max={120} step={5}
                onChange={e => set('duration', e.target.value)} />
            </label>
          </div>

          <div className="form-row">
            <label>Estado
              <select value={form.status} onChange={e => set('status', e.target.value)}>
                {STATUSES.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
              </select>
            </label>
            <label>Tipo
              <select value={form.type} onChange={e => set('type', e.target.value)}>
                {APPOINTMENT_TYPES.map(t => (
                  <option key={t.value} value={t.value}>{t.label}</option>
                ))}
              </select>
            </label>
          </div>

          <label>Motivo
            <input type="text" value={form.reason} onChange={e => set('reason', e.target.value)} />
          </label>

          <label>Notas
            <textarea value={form.notes} rows={3} onChange={e => set('notes', e.target.value)} />
          </label>

          {form.status === 'cancelled' && (
            <label>Razón de cancelación
              <input type="text" value={form.cancellationReason}
                onChange={e => set('cancellationReason', e.target.value)}
                placeholder="Opcional" />
            </label>
          )}

          <div className="modal-actions">
            <button type="button" className="btn-secondary" onClick={onClose}>Cerrar</button>
            {onCancel && (
              <button type="button" className="btn-danger"
                onClick={onCancel}
                disabled={appointment.status === 'cancelled'}>
                Cancelar cita
              </button>
            )}
            <button type="submit" className="btn-primary" disabled={saving}>
              {saving ? 'Guardando...' : 'Guardar cambios'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
